export default [
  {
    id: '1', name: "重启", type: "", isFold: false,
    btType: "danger", orderName: "terminal.reboot", orderType: 'restart_control'
  },
  {
    id: '2', name: "关屏", type: "", isFold: false,
    bttype: "danger", orderName: "terminal.offscreen", orderType: 'offscreen_control'
  },
  {
    id: '3', name: "开屏", type: "", isFold: false,
    btType: "success", orderName: "terminal.onscreen", orderType: 'onscreen_control'
  },
  {
    id: '4', name: "定时指令", type: "", isFold: false,
    btType: "primary", orderName: 'terminal.timeTask', orderType: "schedule_setting"
  },
  {
    id: '5', name: "亮度调节", type: "", isFold: false,
    btType: 'primary', orderName: 'terminal.conBright', orderType: 'setting/bright'
  },
  {
    id: '6', name: "声音调节", type: "", isFold: false,
    btType: 'primary', orderName: 'terminal.conVoice', orderType: 'setting/voice'
  },
  {
    id: '7', name: "继电器开关", type: "", isFold: false,
    btType: 'primary', orderName: 'terminal.relay', orderType: 'relay_control'
  },
  {
    id: '8', name: "时区校准", type: "", isFold: false,
    btType: "primary", orderName: 'terminal.timeZone', orderType: "time_zone_setting"
  },
  {
    id: '9', name: "信号切换", type: "", isFold: false,
    btType: "primary", orderName: 'terminal.signalChange', orderType: "signal_change"
  },
  {
    id: '10', name: "多屏同步", type: "", isFold: false,
    btType: 'primary', orderName: 'terminal.synScreen', orderType: 'sync_play'
  },
  {
    id: '11', name: "定时播放开关", type: "", isFold: false,
    btType: 'primary', orderName: 'terminal.timePlay', orderType: 'schedule_running'
  },
  {
    id: '12', name: "定时开关机", type: "", isFold: false,
    btType: 'primary', orderName: 'terminal.timeOn', orderType: 'power_onoff'
  },
  {
    id: '13', name: "批量升级", type: "", isFold: false,
    btType: "primary", orderName: "terminal.batchUpdate", orderType: "batch_update"
  },
  {
    id: '14', name: "截屏", type: "", isFold: false,
    btType: "primary", orderName: "ctch47", orderType: "capture_save"
  },
  {
    id: '15', name: "云看护", type: "", isFold: false,
    btType: "primary", orderName: "ctcdde19", orderType: "set_cloud_monitor_time"
  },
  {
    id: '16', name: "上传日志", type: "", isFold: false,
    btType: "primary", orderName: "ssdcbl1", orderType: "up_logs"
  },
  {
    id: '17', name: "添加流媒体", type: "", isFold: false,
    btType: "primary", orderName: "ssdcbl2", orderType: "streaming_media"
  },
  {
    id: '18', name: "紧急版式", type: "", isFold: false,
    btType: "primary", orderName: "ctch54", orderType: "program_play_by_name"
  },
  {
    id: '19', name: "紧急信息", type: "", isFold: false,
    btType: "primary", orderName: "ctch45", orderType: "send_text_info",
  },
  {
    id: '20', name: "播表撤回", type: "", isFold: false,
    btType: "primary", orderName: "ssdcbl3", orderType: "schedule_back"
  },
  {
    id: '20', name: "终端导出", type: "", isFold: false,
    btType: "primary", orderName: "ssdcbl4", orderType: "device_export"
  },
];